import React, { useState } from "react";
import Top20Books from "./components/Top20Books";
import ReadingLogsLineChart from "./components/ReadingLogsLineChart";
import { Link } from "@reach/router";
import compareDemographicsImg from '../../../../images/data/compareDemographicsImg.svg';

import AccountStats from "./components/AccountsStats";
import WebinarBanner from "./components/WebinarBanner";
import moment from "moment";
import styles from './SchoolData.module.scss';
import { SCHOOL_MONTHLY_REPORT_DATA, ACADEMIC_MONTHLY_REPORTS_DATA } from "../../services/graphql";
import { useQuery, useLazyQuery } from "@apollo/react-hooks";
import { Loader, Button } from "@squirrellearningltd/go-teacher-components";
import CompareByDemography from "./components/CompareByDemography";
import { getUrl, APPS } from '@squirrellearningltd/go-shared-utils';

const DataDashDemoContent = ({ isSchoolAdmin }) => {
    const [seletctByDemography, setSelectByDemography] = useState(false);
    const [boomReaderNationalAverageSelected, setBoomReaderNationalAverageSelected] = useState(false);

    const currentAcadYear = moment().toDate().getMonth() >= 8 ? moment().year() + 1 : moment().year()

    const data = {
        "schoolByCode": {
            "id": "U2Nob29sLTgy",
            "name": "Axe Edge Academy",
            "academicYearReports": [
                {
                    "id": "QWNhZGVtaWNZZWFyQWdncmVnYXRlZFJlcG9ydC04ODM=",
                    "activeAccounts": 110,
                    "purchasedAccounts": 100,
                    "activeParents": 3,
                    "subscriptionExpiresAt": "2026-10-10",
                    "academicYear": 2026,
                    "groupBooksCompleted": 0,
                    "homeBooksCompleted": 0,
                    "libraryBooksCompleted": 0,
                    "schoolBooksCompleted": 1,
                    "totalBooksCompleted": 1,
                    "parentLogs": 3,
                    "studentLogs": 0,
                    "teacherLogs": 0,
                    "totalLogs": 3400,
                    "topBooksCompleted": [
                        {
                            "id": "0",
                            "title": "Book Title",
                            "author": "Author Name",
                        },
                        {
                            "id": "1",
                            "title": "Book Title",
                            "author": "Author Name",
                        },
                        {
                            "id": "2",
                            "title": "Book Title",
                            "author": "Author Name",
                        },
                        {
                            "id": "3",
                            "title": "Book Title",
                            "author": "Author Name",
                        },
                        {
                            "id": "4",
                            "title": "Book Title",
                            "author": "Author Name",
                        },
                        {
                            "id": "5",
                            "title": "Book Title",
                            "author": "Author Name",
                        },
                        {
                            "id": "6",
                            "title": "Book Title",
                            "author": "Author Name",
                        },
                        {
                            "id": "7",
                            "title": "Book Title",
                            "author": "Author Name",
                        },
                        {
                            "id": "8",
                            "title": "Book Title",
                            "author": "Author Name",
                        }, {
                            "id": "9",
                            "title": "Book Title",
                            "author": "Author Name",
                        },

                    ],
                },
                {
                    "id": "QWNhZGVtaWNZZWFyQWdncmVnYXRlZFJlcG9ydC04ODM=",
                    "activeAccounts": 110,
                    "purchasedAccounts": 100,
                    "activeParents": 3,
                    "subscriptionExpiresAt": "2026-10-10",
                    "academicYear": 2025,
                    "groupBooksCompleted": 0,
                    "homeBooksCompleted": 0,
                    "libraryBooksCompleted": 0,
                    "schoolBooksCompleted": 1,
                    "totalBooksCompleted": 1,
                    "parentLogs": 3,
                    "studentLogs": 0,
                    "teacherLogs": 0,
                    "totalLogs": 2750,
                },
                {
                    "id": "QWNhZGVtaWNZZWFyQWdncmVnYXRlZFJlcG9ydC04ODM=",
                    "activeAccounts": 110,
                    "purchasedAccounts": 100,
                    "activeParents": 3,
                    "subscriptionExpiresAt": "2026-10-10",
                    "academicYear": 2024,
                    "groupBooksCompleted": 0,
                    "homeBooksCompleted": 0,
                    "libraryBooksCompleted": 0,
                    "schoolBooksCompleted": 1,
                    "totalBooksCompleted": 1,
                    "parentLogs": 3,
                    "studentLogs": 0,
                    "teacherLogs": 0,
                    "totalLogs": 1300,
                }
            ],
            "monthlyReportData": [
                {
                    "id": "TW9udGhseVJlcG9ydERhdGEtMjg3MA==",
                    "month": 9,
                    "year": 2025,
                    "groupBooksCompleted": 0,
                    "homeBooksCompleted": 0,
                    "libraryBooksCompleted": 0,
                    "schoolBooksCompleted": 0,
                    "totalBooksCompleted": 0,
                    "parentLogs": 350,
                    "studentLogs": 300,
                    "teacherLogs": 350,
                    "totalLogs": 1000,
                },
                {
                    "id": "TW9udGhseVJlcG9ydERhdGEtMjg4MQ==",
                    "month": 10,
                    "year": 2025,
                    "groupBooksCompleted": 0,
                    "homeBooksCompleted": 0,
                    "libraryBooksCompleted": 0,
                    "schoolBooksCompleted": 0,
                    "totalBooksCompleted": 0,
                    "parentLogs": 1000,
                    "studentLogs": 500,
                    "teacherLogs": 100,
                    "totalLogs": 1600,
                },
                {
                    "id": "TW9udGhseVJlcG9ydERhdGEtMjg5Mg==",
                    "month": 11,
                    "year": 2025,
                    "groupBooksCompleted": 0,
                    "homeBooksCompleted": 0,
                    "libraryBooksCompleted": 0,
                    "schoolBooksCompleted": 0,
                    "totalBooksCompleted": 0,
                    "parentLogs": 1000,
                    "studentLogs": 600,
                    "teacherLogs": 100,
                    "totalLogs": 1700,
                },
                {
                    "id": "TW9udGhseVJlcG9ydERhdGEtMjkwMw==",
                    "month": 12,
                    "year": 2025,
                    "groupBooksCompleted": 0,
                    "homeBooksCompleted": 0,
                    "libraryBooksCompleted": 0,
                    "schoolBooksCompleted": 0,
                    "totalBooksCompleted": 0,
                    "parentLogs": 900,
                    "studentLogs": 100,
                    "teacherLogs": 100,
                    "totalLogs": 1100,
                },
                {
                    "id": "TW9udGhseVJlcG9ydERhdGEtMjkxNA==",
                    "month": 1,
                    "year": 2026,
                    "groupBooksCompleted": 0,
                    "homeBooksCompleted": 0,
                    "libraryBooksCompleted": 0,
                    "schoolBooksCompleted": 0,
                    "totalBooksCompleted": 0,
                    "parentLogs": 1000,
                    "studentLogs": 200,
                    "teacherLogs": 200,
                    "totalLogs": 1400,
                },
                {
                    "id": "TW9udGhseVJlcG9ydERhdGEtMjkyNQ==",
                    "month": 2,
                    "year": 2026,
                    "groupBooksCompleted": 0,
                    "homeBooksCompleted": 0,
                    "libraryBooksCompleted": 0,
                    "schoolBooksCompleted": 0,
                    "totalBooksCompleted": 0,
                    "parentLogs": 1000,
                    "studentLogs": 200,
                    "teacherLogs": 300,
                    "totalLogs": 1500,
                },
                {
                    "id": "TW9udGhseVJlcG9ydERhdGEtMjkyNQ==",
                    "month": 3,
                    "year": 2026,
                    "groupBooksCompleted": 0,
                    "homeBooksCompleted": 0,
                    "libraryBooksCompleted": 0,
                    "schoolBooksCompleted": 0,
                    "totalBooksCompleted": 0,
                    "parentLogs": 1000,
                    "studentLogs": 400,
                    "teacherLogs": 500,
                    "totalLogs": 1900,
                },
                {
                    "id": "TW9udGhseVJlcG9ydERhdGEtMjkyNQ==",
                    "month": 4,
                    "year": 2026,
                    "groupBooksCompleted": 0,
                    "homeBooksCompleted": 0,
                    "libraryBooksCompleted": 0,
                    "schoolBooksCompleted": 0,
                    "totalBooksCompleted": 0,
                    "parentLogs": 1000,
                    "studentLogs": 100,
                    "teacherLogs": 200,
                    "totalLogs": 1300,
                },
                {
                    "id": "TW9udGhseVJlcG9ydERhdGEtMjkyNQ==",
                    "month": 5,
                    "year": 2026,
                    "groupBooksCompleted": 0,
                    "homeBooksCompleted": 0,
                    "libraryBooksCompleted": 0,
                    "schoolBooksCompleted": 0,
                    "totalBooksCompleted": 0,
                    "parentLogs": 300,
                    "studentLogs": 100,
                    "teacherLogs": 100,
                    "totalLogs": 500,
                },
                {
                    "id": "TW9udGhseVJlcG9ydERhdGEtMjkyNQ==",
                    "month": 6,
                    "year": 2026,
                    "groupBooksCompleted": 0,
                    "homeBooksCompleted": 0,
                    "libraryBooksCompleted": 0,
                    "schoolBooksCompleted": 0,
                    "totalBooksCompleted": 0,
                    "parentLogs": 0,
                    "studentLogs": 0,
                    "teacherLogs": 0,
                    "totalLogs": 0,
                },
                {
                    "id": "TW9udGhseVJlcG9ydERhdGEtMjkyNQ==",
                    "month": 7,
                    "year": 2026,
                    "groupBooksCompleted": 0,
                    "homeBooksCompleted": 0,
                    "libraryBooksCompleted": 0,
                    "schoolBooksCompleted": 0,
                    "totalBooksCompleted": 0,
                    "parentLogs": 0,
                    "studentLogs": 0,
                    "teacherLogs": 0,
                    "totalLogs": 0,
                },
                {
                    "id": "TW9udGhseVJlcG9ydERhdGEtMjkyNQ==",
                    "month": 8,
                    "year": 2026,
                    "groupBooksCompleted": 0,
                    "homeBooksCompleted": 0,
                    "libraryBooksCompleted": 0,
                    "schoolBooksCompleted": 0,
                    "totalBooksCompleted": 0,
                    "parentLogs": 0,
                    "studentLogs": 0,
                    "teacherLogs": 0,
                    "totalLogs": 0,
                }
            ],
            "yearGroups": [
                {
                    "id": "0",
                    "code": "9",
                    "name": "Year 1",
                },
                {
                    "id": "1",
                    "code": "12",
                    "name": "Year 2",
                },
                {
                    "id": "2",
                    "code": "14",
                    "name": "Year 3",
                },
                {
                    "id": "3",
                    "code": "15",
                    "name": "Year 4",
                },
                {
                    "id": "4",
                    "code": "13",
                    "name": "Year 5",
                },
                {
                    "id": "5",
                    "code": "13",
                    "name": "Year 6",
                }
            ],
            "students": [
                {
                    "id": "U3R1ZGVudC0yNjQ=",
                },
                {
                    "id": "U3R1ZGVudC00NTQ=",
                },
                {
                    "id": "U3R1ZGVudC0yMTk=",
                },
                {
                    "id": "U3R1ZGVudC0yMjA=",
                },
                {
                    "id": "U3R1ZGVudC0yMjM=",
                },
                {
                    "id": "U3R1ZGVudC0xODg=",
                },
                {
                    "id": "U3R1ZGVudC0yMTg=",
                },
                {
                    "id": "U3R1ZGVudC0yMjE=",
                },
                {
                    "id": "U3R1ZGVudC0zNDA=",
                },
                {
                    "id": "U3R1ZGVudC0zNzg=",
                },
                {
                    "id": "U3R1ZGVudC00NDM=",
                },
                {
                    "id": "U3R1ZGVudC0zOTk=",
                },
                {
                    "id": "U3R1ZGVudC0xODk=",
                },
                {
                    "id": "U3R1ZGVudC0xODU=",
                },
                {
                    "id": "U3R1ZGVudC0xODc=",
                },
                {
                    "id": "U3R1ZGVudC0xOTA=",
                },
                {
                    "id": "U3R1ZGVudC0yNTY=",
                },
                {
                    "id": "U3R1ZGVudC0yNTQ=",
                },
                {
                    "id": "U3R1ZGVudC0yNTU=",
                },
                {
                    "id": "U3R1ZGVudC0zNTg=",
                },
                {
                    "id": "U3R1ZGVudC0zMzg=",
                },
                {
                    "id": "U3R1ZGVudC0zOTg=",
                },
                {
                    "id": "U3R1ZGVudC00MDA=",
                },
                {
                    "id": "U3R1ZGVudC00MDE=",
                },
                {
                    "id": "U3R1ZGVudC00NTU=",
                },
                {
                    "id": "U3R1ZGVudC0zOTc=",
                },
                {
                    "id": "U3R1ZGVudC00NTc=",
                },
                {
                    "id": "U3R1ZGVudC0xOTE=",
                },
                {
                    "id": "U3R1ZGVudC0yNTI=",
                },
                {
                    "id": "U3R1ZGVudC05NTk=",
                },
                {
                    "id": "U3R1ZGVudC0zODU=",
                },
                {
                    "id": "U3R1ZGVudC05NTU=",
                },
                {
                    "id": "U3R1ZGVudC03MjY=",
                },
                {
                    "id": "U3R1ZGVudC05NTg=",
                },
                {
                    "id": "U3R1ZGVudC05NjA=",
                },
                {
                    "id": "U3R1ZGVudC05NjE=",
                },
                {
                    "id": "U3R1ZGVudC05NjI=",
                },
                {
                    "id": "U3R1ZGVudC0yMTc=",
                },
                {
                    "id": "U3R1ZGVudC05NjU=",
                },
                {
                    "id": "U3R1ZGVudC05NjY=",
                },
                {
                    "id": "U3R1ZGVudC05Njc=",
                },
                {
                    "id": "U3R1ZGVudC05Njg=",
                },
                {
                    "id": "U3R1ZGVudC05Njk=",
                },
                {
                    "id": "U3R1ZGVudC05NzA=",
                },
                {
                    "id": "U3R1ZGVudC05NzE=",
                },
                {
                    "id": "U3R1ZGVudC0xODQ=",
                },
                {
                    "id": "U3R1ZGVudC0xODY=",
                },
                {
                    "id": "U3R1ZGVudC0yNDM=",
                },
                {
                    "id": "U3R1ZGVudC0yNDQ=",
                },
                {
                    "id": "U3R1ZGVudC04ODU=",
                },
                {
                    "id": "U3R1ZGVudC0zMTk=",
                },
                {
                    "id": "U3R1ZGVudC0zMjE=",
                },
                {
                    "id": "U3R1ZGVudC0zMjQ=",
                },
                {
                    "id": "U3R1ZGVudC00Mzk=",
                },
                {
                    "id": "U3R1ZGVudC00NDE=",
                },
                {
                    "id": "U3R1ZGVudC00NDI=",
                },
                {
                    "id": "U3R1ZGVudC00NDQ=",
                },
                {
                    "id": "U3R1ZGVudC00NDU=",
                },
                {
                    "id": "U3R1ZGVudC00NTY=",
                },
                {
                    "id": "U3R1ZGVudC05MDY=",
                },
                {
                    "id": "U3R1ZGVudC05MTE=",
                },
                {
                    "id": "U3R1ZGVudC05MTY=",
                },
                {
                    "id": "U3R1ZGVudC05NTI=",
                },
                {
                    "id": "U3R1ZGVudC05NjM=",
                },
                {
                    "id": "U3R1ZGVudC05NTQ=",
                },
                {
                    "id": "U3R1ZGVudC05NTY=",
                },
                {
                    "id": "U3R1ZGVudC05NTM=",
                },
                {
                    "id": "U3R1ZGVudC0yNjM=",
                },
                {
                    "id": "U3R1ZGVudC0zNzY=",
                },
                {
                    "id": "U3R1ZGVudC00NDA=",
                },
                {
                    "id": "U3R1ZGVudC05Nzc=",
                },
                {
                    "id": "U3R1ZGVudC05Nzg=",
                },
                {
                    "id": "U3R1ZGVudC05ODQ=",
                },
                {
                    "id": "U3R1ZGVudC05ODE=",
                },
                {
                    "id": "U3R1ZGVudC05ODI=",
                },
                {
                    "id": "U3R1ZGVudC05ODU=",
                },
                {
                    "id": "U3R1ZGVudC05ODY=",
                },
                {
                    "id": "U3R1ZGVudC05ODg=",
                },
                {
                    "id": "U3R1ZGVudC05ODk=",
                },
                {
                    "id": "U3R1ZGVudC05Nzk=",
                },
                {
                    "id": "U3R1ZGVudC05ODc=",
                },
                {
                    "id": "U3R1ZGVudC0zMzk=",
                },
                {
                    "id": "U3R1ZGVudC05ODA=",
                }
            ],
        }
    }

    const averageData = {
        "academicMonthlyReports": [
            {
                "academicYear": 2025,
                "year": 2024,
                "avgGroupBooks": 0,
                "avgHomeBooks": 0,
                "avgLibraryBooks": 0,
                "avgParentLogs": 0.75,
                "avgSchoolBooks": 0.25,
                "avgStudentLogs": 0,
                "avgTeacherLogs": 1,
                "month": 9,
                "studentsCount": 4,
                "totalLogs": 1.75,
                "totalBooks": 0.25,
            },
            {
                "academicYear": 2025,
                "year": 2024,
                "avgGroupBooks": 1.33,
                "avgHomeBooks": 0,
                "avgLibraryBooks": 0,
                "avgParentLogs": 0,
                "avgSchoolBooks": 5.67,
                "avgStudentLogs": 12.67,
                "avgTeacherLogs": 0.33,
                "month": 10,
                "studentsCount": 3,
                "totalLogs": 13,
                "totalBooks": 7,
            },
            {
                "academicYear": 2025,
                "year": 2024,
                "avgGroupBooks": 0,
                "avgHomeBooks": 0,
                "avgLibraryBooks": 0,
                "avgParentLogs": 0.33,
                "avgSchoolBooks": 0.33,
                "avgStudentLogs": 0.33,
                "avgTeacherLogs": 0.33,
                "month": 11,
                "studentsCount": 3,
                "totalLogs": 0.99,
                "totalBooks": 0.33,
            },
            {
                "academicYear": 2025,
                "year": 2024,
                "avgGroupBooks": 0,
                "avgHomeBooks": 0,
                "avgLibraryBooks": 0,
                "avgParentLogs": 0,
                "avgSchoolBooks": 0,
                "avgStudentLogs": 2,
                "avgTeacherLogs": 0,
                "month": 12,
                "studentsCount": 1,
                "totalLogs": 2,
                "totalBooks": 0,
            },
            {
                "academicYear": 2025,
                "year": 2025,
                "avgGroupBooks": 0,
                "avgHomeBooks": 0,
                "avgLibraryBooks": 0,
                "avgParentLogs": 0.14,
                "avgSchoolBooks": 0,
                "avgStudentLogs": 26.71,
                "avgTeacherLogs": 0,
                "month": 2,
                "studentsCount": 7,
                "totalLogs": 26.85,
                "totalBooks": 0,
            },
            {
                "academicYear": 2025,
                "year": 2025,
                "avgGroupBooks": 0,
                "avgHomeBooks": 0,
                "avgLibraryBooks": 0,
                "avgParentLogs": 0,
                "avgSchoolBooks": 0,
                "avgStudentLogs": 10,
                "avgTeacherLogs": 0,
                "month": 3,
                "studentsCount": 1,
                "totalLogs": 10,
                "totalBooks": 0,
            },
            {
                "academicYear": 2025,
                "year": 2025,
                "avgGroupBooks": 0,
                "avgHomeBooks": 0,
                "avgLibraryBooks": 0,
                "avgParentLogs": 0,
                "avgSchoolBooks": 0,
                "avgStudentLogs": 10,
                "avgTeacherLogs": 3,
                "month": 4,
                "studentsCount": 1,
                "totalLogs": 13,
                "totalBooks": 0,
            },
            {
                "academicYear": 2025,
                "year": 2025,
                "avgGroupBooks": 0,
                "avgHomeBooks": 0,
                "avgLibraryBooks": 0,
                "avgParentLogs": 0.5,
                "avgSchoolBooks": 0,
                "avgStudentLogs": 5.25,
                "avgTeacherLogs": 1,
                "month": 5,
                "studentsCount": 4,
                "totalLogs": 6.75,
                "totalBooks": 0,
            }
        ]
    }

    const currentUser = {
        school: {
            classes:
                [
                    {
                        "id": "0",
                        "name": "1 Bees",
                    },
                    {
                        "id": "1",
                        "name": "2 Spiders",
                    },
                    {
                        "id": "2",
                        "name": "3 Ladybugs",
                    },
                    {
                        "id": "3",
                        "name": "4 Butterflies",
                    },
                    {
                        "id": "4",
                        "name": "5 Caterpillars",
                    },
                    {
                        "id": "5",
                        "name": "6 Moths"
                    }

                ]

        }
    }

    const fetchAcademicMonthlyReports = () => {
        setBoomReaderNationalAverageSelected(!boomReaderNationalAverageSelected);
    };

    const { schoolByCode: school } = data;

    return (
        <>
            <div className={styles.demoDataDashBoardContainer}>
                <div className={styles.dashWrapper}>
                    <>
                        <h3 className="u-m-base-3">{school.name}</h3>

                        <WebinarBanner />

                        {school.academicYearReports.find(r => r.academicYear === +currentAcadYear) &&
                            <AccountStats statsData={school.academicYearReports[0]} school={true} />
                        }

                        <ReadingLogsLineChart
                            sourceData={school}
                            boomReaderNationalAverageSelected={boomReaderNationalAverageSelected}
                            averageData={averageData}
                            requestAverageDataCallback={fetchAcademicMonthlyReports}
                            withBRNA={true}
                        />

                        <div className={`${styles.row2Cols} ${'u-m-top-3'}`}>
                            <div className='card card-shadow u-m-left-2'>
                                <div className="card-body u-flex-center">
                                    <div className="u-flex-center">
                                        <img src={compareDemographicsImg} alt='' />
                                        <p className="lead u-bold u-m-left-2">Compare reading data by demography</p>
                                    </div>
                                    <Button className='u-m-left-auto' onClick={() => setSelectByDemography(true)}>Compare</Button>
                                </div>
                            </div>
                        </div>

                        <div className='card card-shadow u-m-base-3 u-m-top-4'>
                            <div className="card-body u-flex-center">
                                <div className={styles.row2Cols}>
                                    <div className="u-p-right-2">
                                        <h2 className="heavy u-m-base-2">Year groups</h2>
                                        <ul className='list-group'>
                                            {school.yearGroups.sort((a, b) => +a.code - +b.code).map(yg =>
                                                <li key={`yg-${yg.id}`} className="list-item u-justify-between u-p-top-2 u-p-base-2">
                                                    {/* <Link to={`/dataDashboard/year/${yg.code}/${currentUser.school.id}`}>  */}
                                                    <span className="u-bold">{yg.name}</span>
                                                    {/* </Link> */}
                                                    {/* <a>Xl</a> */}
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                    <div className="u-p-left-2">
                                        <h2 className="heavy u-m-base-2">Classes</h2>
                                        <ul className='list-group'>
                                            {currentUser?.school.classes.map(kls => (
                                                <li key={`cls-${kls.id}`} className="list-item u-justify-between u-p-top-2 u-p-base-2">
                                                    {/* <Link to={`/dataDashboard/class/${kls.id}`}> */}
                                                    <span className="u-bold"> {kls.name}</span>
                                                    {/* </Link> */}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Top20Books books={school.academicYearReports[0].topBooksCompleted} />
                    </>
                </div>

                <div className={styles.card}>
                    <h1>Welcome to the BoomReader Data Dashboard</h1>
                    <hr className={styles.divider} />

                    <p>You're currently viewing demo data, so the information shown here is not connected to your school or pupils.</p>

                    <p>This trial is designed to help you explore the dashboard's features and see how it could support reading insights across your school.</p>

                    <p>The BoomReader Data Dashboard is available for &pound;1 per child, in addition to your existing BoomReader subscription.</p>

                    <p>Take a look around and see what it can do!</p>

                    <p>If you have further questions please email <a href="mailto:support@boomhub.app">support@boomhub.app</a></p>

                    {isSchoolAdmin ?
                        <a className={styles.upgradeBtn} href={`${getUrl(APPS.go_portal_teacher)}/settings/boomreader`}>UPGRADE</a> :
                        <p className="small">Contact your system admin to sign up.</p>}
                </div>
            </div>

        </>
    )

}

export default DataDashDemoContent;